window.onload = function() {

  //Mobile Nav functionality
  (function(global) {

    "use strict"

    /*
      Create a new nav object and a reference to it globally outside of the scope of this IIFE
    
    var nav = new MobileNav(global);
    global.nav = nav;

    /*
      Hide Show full mobile nav

    nav.toggler.addEventListener("click", function(){
      nav.toggle(nav.mobileWrap);
    });

    /*
      Hide Show Sub Menus in mobile nav
      -
      So I don't forget how this works. The nav object has two properties:
        - subMenuList -> Array of DOMElements
        - subMenuListToggle -> Array of DOMElements
      1. The loop iterates at the same length as each of them and adds an event Listener
      to the relevent subMenuListToggler object (which is the element the user clicks)
      2. When the event for the relevent subMenuListToggler is fired, 'this' is pointing to
      the DOMElement that was clicked. So we use a jQuery.next() to grab the element
      next to the Toggle Element that 'this' is pointing to, which is the element we want to
      show and hide.
      3. Then we pass that element into the nav object's toggle function, which adds or
      removes the active class based on it's state.

    for (var i = 0; i < nav.subMenuListToggle.length; i++) {
      nav.subMenuListToggle[i].addEventListener("mouseenter", function(){
        console.log(this); //proof that we're pointing to the same element that was clicked on.
        var subList = $(this).next(); //getting the submenu that we want to show and hide, which sits next to the toggle dom element that was clicked.
        nav.toggle(subList); //add or remove visibility to the returned submenu based on it's current state.
      });
    }

    /*
      Make nav stick to the top of the viewport based on scroll event from the user.
    window.addEventListener("scroll", function(){
      setTimeout(function(){
        nav.stick();
      }, 500);
    });
    */

  })(window);

  //WOW setup
  (function(global) {

    "use strict"

    //global.wow = new WOW().init();

  })(window);

  //Click Toggles 
  (function(global){

    "use strict"

    /* Reveal Boxes */
    $(".reveal-label").on("click", function(){
      console.log("Clicked");
      var elem = $(this).next();
      if ( $(elem).hasClass("active") ) {
        $(elem).removeClass("active");
      } else {
        $(elem).addClass("active");
      }
    });

  })(window);

  //Hover Toggles
  (function(global){

    "use strict"

    var hoverableElements = $('.hoverable');
    console.log(hoverableElements);
    for (var i = 0; i < hoverableElements.length; i++) {
      hoverableElements[i].addEventListener("mouseenter", function(){
        var elem = $(this).find('.hover-wrap');
        $(elem).addClass('active');
      });
      hoverableElements[i].addEventListener("mouseleave", function(){
         var elem = $(this).find('.hover-wrap');
        $(elem).removeClass('active');
      });
    }

  })(window);

}

/* Smooth scroll to id anchors on click */
$(function() {
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000);
        return false;
      }
    }
  });
});

//Document Ready
$(document).ready( function(){

  //Search function 
  var searchInput = document.getElementById("SearchInput");
  var searchTrigger = document.getElementById("SearchTrigger");

  //searchTrigger.addEventListener("click", searchTime);

  function searchTime(e){
    e.preventDefault();
    var searchVal = $(this).prev().val();

    //Create querystring
    var str = "?q=" + searchVal;
    var url = $(searchTrigger).attr("href");
    var concat = url + str;
    window.location = concat;
  }

  function searchToggle() {

  }

  //Slick
  //$(".slick-init").slick();

});

$(document).ready(function() {
    $('.product-box').matchHeight();
});

// leanModal v1.0 by Ray Stone - http://finelysliced.com.au
(function($){$.fn.extend({leanModal:function(_1){var _2={top:100,overlay:0.6};_1=$.extend(_2,_1);return this.each(function(){var o=_1;$(this).click(function(e){var _3=$("<div id='lean_overlay'></div>");var _4=$(this).data("rel");$("body").append(_3);$("#lean_overlay, .fancybox-close").click(function(){_5(_4);});var _6=$(_4).outerHeight();var _7=$(_4).outerWidth();$("#lean_overlay").css({"display":"block",opacity:0});$("#lean_overlay").fadeTo(0,o.overlay);if($(_4).hasClass('modal_product')){$(_4).css({"position":"fixed"});}else{$(_4).css({"position":"fixed"});};$(_4).css({"display":"block",opacity:0,"z-index":11000,"left":50+"%","margin-left":-(_7/2)+"px","top":o.top+"px"});$(_4).fadeTo(200,1);e.preventDefault();});});function _5(_8){$("#lean_overlay").fadeOut(200).remove();$(_8).css({"display":"none"});};}});})(jQuery);


if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
    $(".quick_shop").remove();
  } else {
    $('.thumbnail:not(".one-image")').hover(function(){ $(this).children('.quick_shop').show(); $(this).addClass('swap');  }, function(){ $(this).children('.quick_shop').hide(); $(this).removeClass('swap'); })

    $(".quick_shop").leanModal();
      $('.product_image_col.feature_image').click(function() {
        $.fancybox.open($(".fancybox"), {"padding": 0, "nextEffect": "fade", "prevEffect": "fade", "index": $(this).find('a').data('index'),
        helpers : {
          thumbs  : {
            width : 50,
            height  : 50
          }
        }});
        return false;     
      });
  }

$('.slick-track').slick({
 centerMode: true,
});




